import e from "./index885.js";
import r from "./index815.js";
var o = "[object Set]";
function s(t) {
  return r(t) && e(t) == o;
}
export {
  s as default
};
